/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { colors } from '@apollo/space-kit/colors';
import { Rocket2 } from '@apollo/space-kit/illustrations/Rocket2';
import { jsx } from '@emotion/react';

export const OperationCollectionsLogInPrompt = () => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="mt-8 flex flex-col items-center">
        <Rocket2
          className="w-40 text-transparent"
          css={{
            '[fill="#F18686"]': {
              fill: 'transparent',
            },
            '[fill="#74B0F4"]': {
              fill: 'transparent',
            },
            '[stroke="#464646"]': {
              stroke: colors.blilet.light,
            },
            'g.stars, g[fill-rule="evenodd"] > g': {
              'path[fill="#CAD0D8"]': {
                fill: 'transparent',
                stroke: colors.blilet.base,
              },
              'circle[fill="#CAD0D8"]': {
                fill: colors.blilet.base,
              },
            },
          }}
        />{' '}
        <div className="text-body-sm mt-3 text-secondary">
          Log in to your Studio account to save operations in your Sandbox.
        </div>
      </div>
    </div>
  );
};
